<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Profilim</h3>
          </div>
        </div>
      </div>
    </div>

    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->
          <div class="m-portlet">
            <!--begin::Form-->
            <form class="m-form m-form--fit m-form--label-align-right">
              <div class="m-portlet__body m-form-box-cont">
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Kullanıcı Tam Adı</label>
                    <input
                      type="text"
                      :class="{ 'is-invalid': $v.user.fullName.$error }"
                      v-model="user.fullName"
                      class="form-control m-input"
                      placeholder="Kullanıcı Adı giriniz."
                    />
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Kullanıcı Epostası</label>
                    <input
                      type="text"
                      :class="{ 'is-invalid': $v.user.email.$error }"
                      v-model="user.email"
                      class="form-control m-input"
                      placeholder="Eposta giriniz."
                    />
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Sistem Kullanıcı Adı</label>
                    <input
                      type="text"
                      :class="{ 'is-invalid': $v.user.userName.$error }"
                      v-model="user.userName"
                      class="form-control m-input"
                      placeholder="Sistem Kullanıcı Adı giriniz."
                    />
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Şifre</label>
                    <input
                      type="password"
                      :class="{ 'is-invalid': $v.user.password.$error }"
                      v-model="user.password"
                      class="form-control m-input"
                      placeholder="Şifre giriniz"
                    />
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Şifre Tekrar</label>
                    <input
                      type="password"
                      :class="{ 'is-invalid': $v.user.repeatPassword.$error }"
                      v-model="user.repeatPassword"
                      class="form-control m-input"
                      placeholder="Tekrar Şifre giriniz"
                    />
                  </div>
                </div>
              </div>
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                      <button
                        type="button"
                        @click="updateMyProfile()"
                        class="spbtn"
                      >KAYDET</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <!--end::Form-->
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
import { _getMyProfile, _updateMyProfile } from "../services/UserService";

export default {
  created() {
    this.getMyProfile();
  },

  data() {
    return {
      user: {
        id: 0,
        fullName: "",
        email: "",
        userName: "",
        password: "",
        repeatPassword: "",
        tenantId: this.$store.getters.tenantId
      }
    };
  },
  validations: {
    user: {
      fullName: { required },
      email: { required, email },
      userName: { required },
      password: { },
      repeatPassword: { sameAsPassword: sameAs("password") }
    }
  },
  methods: {
    updateMyProfile: function() {
      this.$v.user.$touch();
      if (this.$v.user.$error) return;
      _updateMyProfile(this.user).then(response => {
        if (response.data.success) 
          this.$router.push("/");
      });
    },
    getMyProfile: function() {
      _getMyProfile().then(response => {
              if (response.data.success)
        {
  
          this.user = response.data.data;
          //set Password values to empty string if it is not changed password is not updated in service
          this.user.repeatPassword ="";
          this.user.password ="";
        }
        else 
                  this.$router.push("/");
      });
    }
  }
};
</script>